import React, {useState, useEffect, useContext} from 'react'
import { observer } from 'mobx-react-lite'
import { Formik, Form } from 'formik'
import { InsightSchema } from '../../../../../../../schemas/InsightSchema'
import InstaPostInsightForm from './FormsByActionType/InstaPostInsightForm'
import InstaStoryInsightForm from './FormsByActionType/InstaStoryInsightForm'
import InstaReelInsightForm from './FormsByActionType/InstaReelInsightForm'
import TiktokInsightForm from './FormsByActionType/TikTokInsightForm'
import YoutubeInsightForm from './FormsByActionType/YoutubeInsightForm'
import InsightUploadSelectPanel from './InsightUploadSelectPanel'
import ActionInsight from '../../../../../../../models/ActionInsight'
import { useParams } from 'react-router-dom'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import axiosService from '../../../../../../../utils/AxiosService'
import { DraftContext } from '../../../../../../../contexts/DraftContext'
import { CampaignContext } from '../../../../../../../contexts/CampaignContext'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function InsightForm({ insight }) {
  const { id } = useParams()
  const readOnly = useReadOnly()
  const { actions } = useContext(DraftContext)
  const { campaignScenarios } = useContext(CampaignContext)
  const selectedScenario = campaignScenarios?.[0]

  const onSubmit = (values) => {
    axiosService.patch(`/api/project_manager/campaigns/${id}/actions/${insight.action_id}/action_insights/${insight.id}`, {
      action_insight: values
    })
    .then(insight => {
      const action = actions.find(action => action.id === insight.action_id)
      Object.assign(action.action_insight, insight)

      const scenarioAction = selectedScenario?.actions?.find(a => a.id === insight.action_id)
      if (scenarioAction?.action_insight) {
        Object.assign(scenarioAction.action_insight, insight)
      }
      toastSuccess('Insights updated')
    })
    .catch(error => {
      console.log('ERROR UPDATING INSIGHT: ', error)
      toastError('Error updating insight')
    })
  }

  const FormByActionType = {
    'instagram_post': InstaPostInsightForm,
    'instagram_carousel_post': InstaPostInsightForm,
    'instagram_story': InstaStoryInsightForm,
    'instagram_reel': InstaReelInsightForm,
    'tiktok_video': TiktokInsightForm,
    'youtube_video': YoutubeInsightForm,
    'youtube_short': YoutubeInsightForm,
    'linkedin_post': InstaPostInsightForm, //same form as insta for now
    'linkedin_video': InstaReelInsightForm, //same form as insta for now
    'linkedin_newsletter': InstaPostInsightForm,
    'pinterest_pin': InstaPostInsightForm,
    'podcast_episode': InstaPostInsightForm,
    'other_item': InstaPostInsightForm,
  }

  const FormForActionType = FormByActionType[insight.action_type]
  const initialValues = insight ? new ActionInsight(insight) : new ActionInsight()

  return (
    <Formik
      initialValues={initialValues}
      // validationSchema={InsightSchema}
      onSubmit={onSubmit}
    >
      {({ handleBlur, handleChange, values, touched, errors }) => (
        <Form>
          <fieldset disabled={readOnly}>
            <FormForActionType
              insight={insight}
              formProps={{ handleBlur, handleChange, values, touched, errors }}
              linkedin={['linkedin_post', 'linkedin_video', 'linkedin_newsletter'].includes(insight.action_type)}
            />
          </fieldset>
          <InsightUploadSelectPanel insight={insight}/>
          {!readOnly && (
            <div className='px-2'>
              <button
                type='submit'
                className='mb-4 w-full mt-1 bg-rb-green dark:bg-rb-green text-white dark:text-white text-center py-2 rounded-md'
              >
                Submit insight
              </button>
            </div>
          )}
        </Form>
      )}
    </Formik>
  )
})